import { SEO_PLANS, rm } from "./seo-pricing";


export interface LocalizedMarketingRoute {
  route: string;
  title: string;
  description: string;
  changefreq: "weekly" | "monthly";
  priority: string;
}

export const localizedMarketingRoutes = [
  {
    route: "",
    title: "Anchor Sprint",
    description:
      "Malaysia Digital Status certified technology partner for AI, software development, cloud architecture, and digital transformation.",
    changefreq: "weekly",
    priority: "1.0",
  },
  {
    route: "about-us",
    title: "About Anchor Sprint",
    description:
      "Company story, mission, and technology delivery approach for Malaysian organisations.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "our-people",
    title: "Our People: Jazz Tong and Liew Jee Fong",
    description:
      "Meet Anchor Sprint co-founders Jazz Tong and Liew Jee Fong: software and agent engineering, banking, business evaluation and AI adoption.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "company",
    title: "Company Overview",
    description:
      "Corporate overview for Anchor Sprint Sdn Bhd and its enterprise technology services.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "contact",
    title: "Contact Anchor Sprint",
    description:
      "Contact page for Malaysian businesses planning AI, software, cloud, or digital transformation projects.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "corporate-mission",
    title: "Corporate Mission",
    description:
      "Anchor Sprint mission and commitment to practical digital transformation.",
    changefreq: "monthly",
    priority: "0.6",
  },
  {
    route: "corporate-values",
    title: "Corporate Values",
    description:
      "Core values guiding Anchor Sprint delivery, client service, and innovation.",
    changefreq: "monthly",
    priority: "0.6",
  },
  {
    route: "privacy-policy",
    title: "Privacy Notice",
    description:
      "PDPA privacy notice: what personal data Anchor Sprint collects, why, who processes it, and how to access, correct or stop marketing.",
    changefreq: "monthly",
    priority: "0.3",
  },
  {
    route: "industries-we-serve",
    title: "Industries We Serve",
    description:
      "Industries supported with AI, cloud, software, automation, and integration services.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "anthropic-claude-partner-malaysia-singapore",
    title: "Why we build on Claude",
    description:
      "Why we build on Claude, the certified architects who do it, and a home-grown engineering team delivering in Malaysia and Singapore.",
    changefreq: "monthly",
    priority: "0.9",
  },
  {
    route: "our-partners",
    title: "Our Partners",
    description:
      "Technology partnerships and reseller relationships that support Anchor Sprint clients.",
    changefreq: "monthly",
    priority: "0.6",
  },
  {
    route: "service",
    title: "Services Overview",
    description:
      "Overview of Anchor Sprint services across AI, software development, cloud, integration, and transformation.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "service-details",
    title: "Service Details",
    description:
      "Detailed view of Anchor Sprint enterprise solution areas and service delivery scope.",
    changefreq: "monthly",
    priority: "0.6",
  },
  {
    route: "partners/anthropic-claude-partner",
    title: "Anthropic Claude Partner Malaysia",
    description:
      "Malaysia's homegrown Anthropic Claude Partner Network member: a full team of Claude Certified Architects (CCAR-F) building production Claude agents, RAG and custom agents, and on-demand FDE teams.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "partners/openai-partner",
    title: "OpenAI Select Partner Malaysia",
    description:
      "An OpenAI Select Partner in Malaysia: ChatGPT Business and Enterprise rollout, OpenAI API builds, PDPA governance and HRD Corp claimable ChatGPT training.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "guides/how-to-use-claude-malaysia",
    title: "How to Access & Use Claude in Malaysia (2026 Guide)",
    description:
      "Is Claude available in Malaysia? How to sign up, fix the credit-card problem, plans in MYR, using Claude in Bahasa Malaysia, and the three ways businesses access Claude.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "guides/agent-gpa",
    title: "Agent GPA — how we score an AI agent before it ships",
    description:
      "Our evaluation method: score the manual process first, then every version of the agent against the same cases.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "guides/claude-cowork",
    title: "What is Claude Cowork? The Complete Guide + How to Use It",
    description:
      "Anthropic's desktop agentic AI for knowledge work — what it is, how to use it, Cowork vs Claude Code, honest limitations, and where a custom Claude agent is needed. For Malaysian teams.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "guides/malaysia-budget-2027",
    title: "Malaysia Budget 2027 Made Simple",
    description:
      "Malaysia Budget 2027 in one page: minimum wage, tax relief, MSME tax, STR and SARA, business financing, schools, healthcare and AI, with a free 24-page guide.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "guides/chatgpt-intelligent-ui",
    title: "ChatGPT Intelligent UI: What It Is & Examples",
    description: "Explore ChatGPT Intelligent UI through visual examples, adjustable controls and prompts you can try in ChatGPT.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "guides/chatgpt-plans-malaysia",
    title: "ChatGPT Plans & Pricing Malaysia",
    description:
      "Every ChatGPT plan compared for Malaysian teams: Free, Plus, Pro, Business, Enterprise, Edu and the API, in USD with RM estimates, plus data and PDPA notes.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "guides/claude-plans-malaysia",
    title: "Claude Plans Malaysia: Compare Every Tier",
    description:
      "Side-by-side comparison of every Claude plan for Malaysian teams — pricing, capabilities, and security across Free, Pro, Max, Team, Enterprise, and the API.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "guides/claude-privacy-compliance-malaysia",
    title: "Claude Privacy & Compliance: Individual, Team & Enterprise",
    description:
      "Can your admin see your Claude chats? Privacy, data retention, and compliance (SOC 2, ISO, HIPAA, Compliance API) across Claude Individual, Team, and Enterprise, with PDPA context for Malaysia.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise",
    title: "Enterprise Software & Hardware Malaysia",
    description:
      "Focus enterprise brands supplied in Malaysia: AI and compute, cloud, software licences and hardware. Quotation in RM, SST and MyInvois handled.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "enterprise/enquiry",
    title: "Enterprise Enquiry",
    description:
      "Request an enterprise software or hardware quotation in RM — pick brands, quantities and use case.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/adobe-malaysia",
    title: "Adobe Reseller Malaysia",
    description:
      "Adobe Certified Reseller support for Creative Cloud licensing, VIP pricing, and local deployment.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/microsoft-malaysia",
    title: "Authorised Microsoft Reseller Malaysia",
    description:
      "Authorised Microsoft reseller in Malaysia, including GitHub Enterprise — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/dell-technologies-malaysia",
    title: "Authorised Dell Reseller Malaysia",
    description:
      "Authorised Dell reseller in Malaysia — PowerEdge servers, GPU compute, workstations and storage, quoted in RM.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/red-hat-malaysia",
    title: "Authorised Red Hat Reseller Malaysia",
    description:
      "Authorised Red Hat reseller in Malaysia — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/lenovo-thinkstation-pgx-malaysia",
    title: "Lenovo ThinkStation PGX Malaysia",
    description:
      "Lenovo ThinkStation PGX supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/hp-zgx-nano-malaysia",
    title: "HP ZGX Nano AI Station Malaysia",
    description:
      "HP ZGX Nano AI Station supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/asus-ascent-gx10-malaysia",
    title: "ASUS Ascent GX10 Malaysia",
    description:
      "ASUS Ascent GX10 supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/dell-pro-max-gb10-malaysia",
    title: "Dell Technologies Pro Max with GB10 Malaysia",
    description:
      "Dell Technologies Pro Max with GB10 supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/acer-veriton-gn100-malaysia",
    title: "Acer Veriton GN100 Malaysia",
    description:
      "Acer Veriton GN100 supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/dgx-spark-malaysia",
    title: "DGX Spark Malaysia",
    description:
      "Authorised NVIDIA DGX Spark reseller in Malaysia, supplying the Founders Edition and every OEM build — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/dgx-spark-tender-malaysia",
    title: "DGX Spark Tender & RFQ Support Malaysia",
    description:
      "Tender and RFQ support for NVIDIA DGX Spark in Malaysia — baseline specification, OEM Letter of Authorisation, and a quotation in one working day.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/dgx-spark-malaysia/enquiry",
    title: "DGX Spark Quotation Enquiry",
    description:
      "Request a DGX Spark quotation in Malaysia — pick the OEM build, quantity and workload. Quoted in RM with SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "enterprise/nvidia-malaysia",
    title: "NVIDIA Supplier Malaysia",
    description:
      "NVIDIA GPUs supplied in Malaysia through authorised distribution — quotation in RM, SST and MyInvois handled.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "enterprise/nvidia-malaysia/enquiry",
    title: "NVIDIA GPU Quotation Enquiry",
    description:
      "Request an NVIDIA GPU quotation in Malaysia. Data-centre accelerators require end-user documentation before pricing is released.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "services/ai-solutions",
    title: "AI Solutions",
    description:
      "AI agent development, Claude onboarding and managed operations, and practical AI training for Malaysian teams.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "compliance",
    title: "Technology Compliance Guides",
    description:
      "Plain-English guides to what Malaysian and Singapore regulators and auditors expect from your technology, with paragraph references.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "compliance/bnm-rmit",
    title: "What is BNM RMiT? A Plain-English Guide",
    description:
      "Bank Negara Malaysia's Risk Management in Technology policy in plain English: who it covers, the main requirements, the Sep 2026 reissue and what auditors check.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "ai-governance",
    title: "AI Governance in Malaysia & Singapore",
    description:
      "AI governance for Malaysian and Singapore companies: regulation status (PDPA, draft AI Governance Bill, MAS), Lite/Standard/Regulated tiers, a 90-day plan and free policy templates.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/enterprise-resilience",
    title: "Enterprise Resilience Assessment",
    description:
      "Hands-on resilience engineering — chaos, load-to-failure, DR, SLOs — mapped to BNM RMiT & MAS, plus independent load-test audits.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/claude-managed-service-malaysia",
    title: "Claude Managed Service",
    description:
      "Claude setup, team onboarding, governance, adoption support, and ongoing managed operations for Malaysian organisations.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/ai-agents",
    title: "AI Agents and Automation",
    description:
      "AI agents that automate repetitive workflows — invoicing, reporting, and operations — for Malaysian mid-market teams.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/conversational-ai",
    title: "Conversational AI",
    description:
      "Custom WhatsApp AI chatbots for Malaysian businesses: 24/7 customer replies in Bahasa Malaysia, English, and Chinese.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/cloud-architecture",
    title: "Cloud Architecture",
    description:
      "AWS and cloud architecture services for migration, DevOps, security, and cost optimisation.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/digital-transformation",
    title: "Digital Transformation",
    description:
      "Strategy, automation, AI adoption, and execution support for Malaysian digital transformation programmes.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/hardware-software",
    title: "Hardware and Software",
    description:
      "IT procurement, infrastructure planning, software licensing, and hardware sourcing for Malaysian teams.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/product-management",
    title: "Product Management",
    description:
      "Product strategy, UX planning, agile delivery, and digital product consulting.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/smart-manufacturing",
    title: "Smart Manufacturing",
    description:
      "Industry 4.0, IoT, predictive maintenance, and real-time manufacturing analytics.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/vibe-code-rescue",
    title: "Vibe Code Rescue Malaysia",
    description:
      "Audit and repair software built by prompting AI. Fixed-scope audit, then a fix measured against written criteria — criteria not met, no fee for the fix.",
    changefreq: "monthly",
    priority: "0.9",
  },
  {
    route: "services/software-development",
    title: "Software Development",
    description:
      "Custom software, mobile apps, web applications, and enterprise systems for Malaysian businesses.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/system-integration",
    title: "System Integration",
    description:
      "API, ERP, CRM, middleware, and data integration services for enterprise operations.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/training-education",
    title: "Training and Education",
    description:
      "HRD Corp claimable training for AI, digital transformation, and modern business technology.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "services/website-development",
    title: "Website Development",
    description:
      "Affordable web design and custom website development for SMEs in KL, Selangor, and Malaysia.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "solutions/agent-use-cases",
    title: "AI Agent Use Cases",
    description:
      "A directory of AI agent use cases for Malaysian business — the manual workflow, the agentic redesign, how we build it on Claude, and how we prove it works.",
    changefreq: "weekly",
    priority: "0.8",
  },
  {
    route: "solutions/agent-use-cases/credit-evaluation",
    title: "Credit Evaluation Agent",
    description:
      "How we design and build a credit evaluation agent that reads and cross-checks loan documents and flags discrepancies — human-in-the-loop, BNM/PDPA-aware.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/order-processing",
    title: "Order Processing Agent",
    description:
      "How we design and build a WhatsApp order processing agent that captures items, confirms options and the total, and drops a clean order into your POS — human-in-the-loop, for Malaysian F&B and retail.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/product-enquiry",
    title: "Product enquiry agent",
    description: "Answer product questions instantly on WhatsApp — availability, specs and price — from your own catalogue.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/insurance-claims",
    title: "Insurance claims agent",
    description: "Match a claim against the policy, the report and the receipts — and flag what doesn't add up.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/invoice-matching",
    title: "Invoice matching agent",
    description: "Three-way match of purchase order, delivery order and invoice before a payment goes out.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/cash-application",
    title: "Cash application agent",
    description: "Match incoming bank receipts and POS settlements to open invoices and clear them automatically.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/leave-management",
    title: "Leave & shift-cover agent",
    description: "Take leave and MC requests, check policy and balances, route for approval, and find qualified shift cover.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/bank-reconciliation",
    title: "Bank reconciliation agent",
    description: "Reconcile the bank statement against the cash book both ways, post bank-only items, and flag genuine discrepancies.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/kyc-onboarding",
    title: "Onboarding & KYC agent",
    description: "Check that identity documents, proof of address and application details are consistent.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/contract-review",
    title: "Contract review agent",
    description: "Compare a signed contract against the agreed template and surface the clauses that changed.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/support-triage",
    title: "Support triage agent",
    description: "Read, categorise and route incoming tickets, resolving the routine ones on the spot.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/knowledge-agent",
    title: "Internal knowledge agent",
    description: "Answer staff questions from your own SOPs, policies and handbooks — with the source cited.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/hr-verification",
    title: "HR verification agent",
    description: "Verify that a candidate's certificates, references and stated history line up — before the offer goes out.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/agent-use-cases/corporate-comms",
    title: "Corporate communications consistency agent",
    description: "Turn one approved message into on-brand, fact-consistent versions in every language — checked, flagged, and ready for sign-off.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "solutions/ai-agents-for-logistics",
    title: "AI agents for logistics in Malaysia & Singapore",
    description: "AI agents for order processing, 3-way invoice matching, contract review and support across the Malaysia–Singapore supply chain.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "solutions/ai-agents-for-retail",
    title: "AI agents for retail & F&B in Malaysia & Singapore",
    description: "AI agents that capture WhatsApp orders, answer product enquiries and keep messaging consistent for retail & F&B in Malaysia and Singapore.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "solutions/agent-rescue",
    title: "AI Agent Rescue — fix a broken AI agent",
    description: "Vendor delivered an AI agent that doesn't work? Get a free audit and an honest rectify-or-rebuild verdict. Handover from RM 2,000. Malaysia & Singapore.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "tools/ai-visibility-check",
    title: "Free AI Visibility Check",
    description:
      "Free check of whether ChatGPT, Gemini and Google AI Overviews name your business: five customer questions, who gets named instead, cited sources and what to fix.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "tools/claude-cost-calculator",
    title: "Claude Team vs Enterprise Cost Calculator",
    description:
      "Interactive 3-year TCO calculator for Claude Team vs Enterprise — set your team size and usage mix, compare plans, and download an Excel breakdown for management.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "academy",
    title: "Anchor Academy — HRD Corp claimable AI training",
    description:
      "Instructor-led Claude and Vibe Engineering training in Kuala Lumpur and Singapore — HRD Corp claimable, with the grant and claim filed for you.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "academy/claude-certification",
    title: "Claude Certification Malaysia & Singapore",
    description:
      "The four Anthropic Claude certifications, what each exam costs, and which track each role should take. HRD Corp claimable prep courses with the exam included.",
    changefreq: "monthly",
    priority: "0.9",
  },
  {
    route: "academy/chatgpt-training",
    title: "ChatGPT Training for Teams in Malaysia",
    description:
      "HRD Corp claimable ChatGPT training for business teams: everyday work that ends in real output, and working safely with always-on agents in ChatGPT.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "academy/register-interest",
    title: "Register Interest — Anchor Academy",
    description:
      "Join the waiting list for a Claude certification or Vibe Engineering course. Tell us the course, month, headcount and whether you need the HRD Corp claim filed.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "careers",
    title: "Careers",
    description:
      "Join Anchor Sprint — build agentic AI that Malaysian businesses actually use. Open roles in AI engineering, GTM and business development, plus internships, in Shah Alam.",
    changefreq: "weekly",
    priority: "0.6",
  },
] as const satisfies readonly LocalizedMarketingRoute[];

// English-only country pages (Singapore, en-SG). These are geo-targeted to a
// country, NOT translated to ms/zh — so they live OUTSIDE localizedMarketingRoutes
// (which would force /ms + /zh variants and routeComponents entries via the
// catch-all). The sitemap includes them as single EN URLs; metadata uses
// generateSingaporeMetadata (en-SG hreflang).
export const englishOnlyMarketingRoutes = [
  {
    route: "ai-governance/ai-acceptable-use-policy-template",
    title: "AI Acceptable Use Policy Template",
    description:
      "What an AI acceptable use policy must cover, an excerpt of the AGK-POL-02 template and the data × AI tool matrix from AGK-STD-A02.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    // Prefix route: also marks every /ai-governance/templates/<slug>/ preview as
    // English-only (isEnglishOnlyRoute matches children). Slugs are added to the
    // sitemap from src/content/ai-governance/kit.ts.
    route: "ai-governance/templates",
    title: "AI Governance Templates",
    description:
      "Preview the free AI governance templates in your browser: policy, data handling standard, shadow AI procedure, AI system register, incident log and more.",
    changefreq: "monthly",
    priority: "0.6",
  },
  {
    route: "enterprise/rtx-spark-laptops-malaysia",
    title: "NVIDIA RTX Spark Laptops Malaysia",
    description: "RTX Spark laptops in Malaysia: side-by-side specifications and manufacturer prices for ASUS, Dell, HP, Lenovo, Microsoft and MSI, release dates, and preorder enquiries.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "academy/claude-training-kuala-lumpur",
    title: "Claude AI Training Kuala Lumpur & Selangor",
    description:
      "HRD Corp claimable Claude training for teams in Kuala Lumpur & Selangor — delivered in your office, with a certified trainer once a cohort fills.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "academy/claude-training-penang",
    title: "Claude AI Training Penang",
    description:
      "HRD Corp claimable Claude training for teams in Penang — delivered in your office, with a certified trainer once a cohort fills.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "academy/claude-training-johor",
    title: "Claude AI Training Johor",
    description:
      "HRD Corp claimable Claude training for teams in Johor — delivered in your office, with a certified trainer once a cohort fills.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    // Registered with Intuit as Host domain / Launch URL. Prefix route: also
    // marks /quickbooks-connector/disconnected/ English-only, but only the two
    // routes listed here go in the sitemap (disconnected/ is noindex).
    route: "quickbooks-connector",
    title: "Anchor Sprint QuickBooks Connector for Claude",
    description:
      "Read-only connector that lets Claude Desktop read QuickBooks Online P&L, GST and bank transaction data. Runs on your PC; Anchor Sprint does not store your data.",
    changefreq: "monthly",
    priority: "0.5",
  },
  {
    route: "quickbooks-connector/terms",
    title: "QuickBooks Connector End-User Licence Agreement",
    description:
      "End-User Licence Agreement for the Anchor Sprint QuickBooks Connector for Claude.",
    changefreq: "monthly",
    priority: "0.3",
  },
  {
    route: "invest",
    title: "Investment & partnership",
    description:
      "Anchor Sprint builds and runs production AI agents for businesses in Malaysia and Singapore. Information for investors and partners.",
    changefreq: "monthly",
    priority: "0.5",
  },
  {
    route: "services/ai-consulting-malaysia",
    title: "AI consulting Malaysia — the full adoption lifecycle",
    description:
      "End-to-end AI consulting in Malaysia and Singapore: awareness, tooling, workflow redesign, and adoption measurement. HRD Corp approved, Claude Certified Architects in house.",
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/seo-services-malaysia",
    title: "AI SEO Malaysia",
    description:
      `AI SEO for Malaysian businesses: weekly improvements by an approval-gated AI agent and monthly AI visibility tracking, from ${rm(SEO_PLANS.essential.monthly)}/month.`,
    changefreq: "weekly",
    priority: "0.9",
  },
  {
    route: "services/ai-seo-kuala-lumpur",
    title: "AI SEO agency Kuala Lumpur",
    description:
      `AI SEO for Kuala Lumpur and Klang Valley businesses: weekly improvements by an approval-gated AI agent and monthly AI visibility tracking, from ${rm(SEO_PLANS.essential.monthly)}/month.`,
    changefreq: "weekly",
    priority: "0.8",
  },
  {
    route: "enterprise/sonarqube-malaysia",
    title: "SonarQube Malaysia",
    description:
      "SonarQube licences, setup and training in Malaysia from a Sonar reseller partner: Team and Enterprise plans, SAST, AI CodeFix and agent add-ons, CI/CD integration, HRD Corp workshop.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore",
    title: "Claude AI & agentic development in Singapore",
    description:
      "Claude implementation, partner services, training and managed operations in Singapore, Certified in the Claude Partner Network.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore/claude-implementation",
    title: "Claude implementation Singapore",
    description:
      "Deploy Claude and agentic AI in Singapore — SGD costing, PDPC + IMDA governance, human-in-the-loop.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore/claude-partner",
    title: "Claude partner Singapore",
    description:
      "A homegrown Anthropic Claude Partner Network member serving Singapore from Suntec: a full team of Claude Certified Architects (CCAR-F), RAG and custom agents, and on-demand FDE teams, billed in SGD.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore/claude-training",
    title: "Claude training Singapore",
    description:
      "Claude and agentic-AI training for Singapore teams — prompt, agent and rollout enablement.",
    changefreq: "monthly",
    priority: "0.7",
  },
  {
    route: "singapore/sonarqube",
    title: "SonarQube Singapore",
    description:
      "SonarQube licences quoted in SGD, SAST, the Remediation Agent, CI/CD setup and training in Singapore from a Sonar reseller partner.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore/ai-seo",
    title: "AI SEO Singapore",
    description:
      "AI SEO for Singapore businesses: weekly website fixes by an AI agent and monthly AI visibility tracking in ChatGPT, Gemini and Google AI Overviews, quoted in SGD.",
    changefreq: "monthly",
    priority: "0.8",
  },
  {
    route: "singapore/claude-managed-service",
    title: "Claude managed service Singapore",
    description:
      "Managed Claude operations in Singapore — monitoring, governance, evals and SLA-backed support.",
    changefreq: "monthly",
    priority: "0.7",
  },
] as const satisfies readonly LocalizedMarketingRoute[];

export type SingaporeRouteKey =
  (typeof englishOnlyMarketingRoutes)[number]["route"];

export type LocalizedRouteKey = (typeof localizedMarketingRoutes)[number]["route"];

export const localizedRouteKeys = localizedMarketingRoutes.map(
  ({ route }) => route,
) as LocalizedRouteKey[];

export function getRouteFromSegments(
  segments: string[] = [],
): LocalizedRouteKey | null {
  const route = segments.join("/") as LocalizedRouteKey;

  if (route.startsWith("blog")) {
    return null;
  }

  return localizedRouteKeys.includes(route) ? route : null;
}
